import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { ESignatureClient } from '../../api/esignature-client.service';
import {
    loadAutosentEnvelope,
    loadAutosentEnvelopeSuccess,
    loadAutosentEnvelopeFailure,
    listenForAutosentEnvelopeSignal,
    autosentEnvelopeSignalReceived
} from '../actions/autosend-envelope.actions';
import { switchMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { HubConnectionService } from 'src/app/shared/services/realtime-connection.service';
import { AutogeneratedEnvelopeDto } from '../../api/models/autogenerated-envelope-dto.model';
import { ComplianceReportHubMessage } from 'src/app/shared/services/realtime-constants';

@Injectable({
    providedIn: 'root'
})
export class AutosendEnvelopeEffects {
    constructor(
        private readonly _actions$: Actions,
        private readonly _store: Store,
        private readonly _esignatureClient: ESignatureClient,
        private readonly _complianceReportHubService: HubConnectionService
    ) {}

    loadAutosendEnvelope$ = createEffect(() =>
        this._actions$.pipe(
            ofType(loadAutosentEnvelope),
            switchMap((action) => {
                return this._esignatureClient.getAutogeneratedEnvelope(action.contractId).pipe(
                    map((envelope) => loadAutosentEnvelopeSuccess({ envelope })),
                    catchError((error) => of(loadAutosentEnvelopeFailure({ error })))
                );
            })
        )
    );

    autosentEnvelopeSignalR$ = createEffect(() =>
        this._actions$.pipe(
            ofType(listenForAutosentEnvelopeSignal),
            switchMap((_) =>
                this._complianceReportHubService.complianceReportHub
                    .messagesOf<AutogeneratedEnvelopeDto>(ComplianceReportHubMessage.AUTOSENT_ENVELOPE_NOTIFICATION)
                    .pipe(switchMap((envelope) => of(autosentEnvelopeSignalReceived({ envelope: envelope }))))
            )
        )
    );
}
